<h1 mat-dialog-title [attr.data-cy]="'bbddbdd_h1_1_4_'"
    >Betriebstyp {{ betriebstyp?.betriebstyp_id ? "bearbeiten" : "erstellen" }}</h1
>
<div mat-dialog-content>
    <mat-form-field style="width: 100%">
        <mat-label>Betriebstyp</mat-label>
        <input matInput type="text" [formControl]="betriebstypCtrl" [attr.data-cy]="'bbddbdd_input_1_1_'" />
    </mat-form-field>
    <mat-form-field style="width: 100%">
        <mat-label>Impfstoffzusatz</mat-label>
        <input matInput type="text" [formControl]="impfstoffZusatzCtrl" [attr.data-cy]="'bbddbdd_input_2_1_'" />
    </mat-form-field>
    <mat-form-field style="width: 100%">
        <mat-label>Antibiotikazusatz</mat-label>
        <input matInput type="text" [formControl]="antibiotikaZusatzCtrl" [attr.data-cy]="'bbddbdd_input_3_1_'" />
    </mat-form-field>
    <mat-form-field style="width: 100%">
        <mat-label>Verbotene Wirkstoffe</mat-label>
        <mat-select [formControl]="wirkstoffCtrl" multiple [compareWith]="wirkstoffComparator">
            <mat-option *ngFor="let w of wirkstoffe" [value]="w">{{ w.wirkstoff }}</mat-option>
        </mat-select>
    </mat-form-field>
</div>
<div mat-dialog-actions>
    <span class="spacer"></span>
    <button mat-button (click)="close()" [attr.data-cy]="'bbddbdd_button_1_0_'">Abbrechen</button>
    <button mat-flat-button color="accent" (click)="save()" [attr.data-cy]="'bbddbdd_button_2_0_'">Speichern</button>
</div>
